import script from "./UploadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadForm.vue?vue&type=script&setup=true&lang=js"

import "./UploadForm.vue?vue&type=style&index=0&id=3ff52f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff52f35"]])

export default __exports__